import { StepTypes } from "models/controller";
import { atom } from "recoil";

export const totalStepState = atom<number>({
  key: "totalSteps",
  default: 0,
});

export const currentStepState = atom<number>({
  key: "currentStep",
  default: 0,
});

export const currentProblemState = atom<number>({
  key: "cuurentProblem",
  default: -1,
});

export const stepTypeState = atom<StepTypes>({
  key: "stepType",
  default: StepTypes.INTRO,
});
